import { Routes } from '@angular/router';
import { authGuard } from '@core/auth/auth.guard';
import { userTypeGuard } from '@core/auth/user-type.guard';
import { rootRedirectGuard } from '@core/auth/root-redirect.guard';
import { guestGuard } from '@core/auth/guest.guard';

export const routes: Routes = [
    // Root redirect - redirects based on user_type
    {
        path: '',
        pathMatch: 'full',
        canActivate: [rootRedirectGuard],
        children: [],
    },

    // Auth routes with layout
    {
        path: 'auth',
        loadComponent: () =>
            import('./layouts/auth-layout/auth-layout.component').then(
                (m) => m.AuthLayoutComponent,
            ),
        canActivate: [guestGuard],
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('@features/auth/auth.routes').then(
                        (m) => m.AUTH_ROUTES,
                    ),
            },
        ],
    },

    // Design System Showcase (public)
    // {
    //     path: 'design-system',
    //     loadComponent: () =>
    //         import('./pages/design-system-showcase/design-system-showcase.component').then(
    //             (m) => m.DesignSystemShowcaseComponent,
    //         ),
    // },

    // Unauthorized page (public, must come before guarded routes)
    {
        path: 'unauthorized',
        loadComponent: () =>
            import('./pages/unauthorized/unauthorized.component').then(
                (m) => m.UnauthorizedComponent,
            ),
    },

    // Super Admin routes (desktop layout) - owner user type
    {
        path: '',
        loadComponent: () =>
            import('./layouts/app-layout/app-layout.component').then(
                (m) => m.AppLayoutComponent,
            ),
        canActivate: [authGuard, userTypeGuard('owner')],
        loadChildren: () =>
            import('@features/super-admin/super-admin.routes').then(
                (m) => m.SUPER_ADMIN_ROUTES,
            ),
    },

    // Agency Admin routes (desktop layout) - agency user type
    {
        path: 'agency',
        loadComponent: () =>
            import('./layouts/app-layout/app-layout.component').then(
                (m) => m.AppLayoutComponent,
            ),
        canActivate: [authGuard, userTypeGuard('agency')],
        loadChildren: () =>
            import('@features/agency/agency.routes').then(
                (m) => m.AGENCY_ROUTES,
            ),
    },

    // Employer routes
    {
        path: 'employer',
        loadComponent: () =>
            import('./layouts/app-layout/app-layout.component').then(
                (m) => m.AppLayoutComponent,
            ),
        canActivate: [authGuard, userTypeGuard('employer')],
        loadChildren: () =>
            import('@features/employer/employer.routes').then(
                (m) => m.EMPLOYER_ROUTES,
            ),
    },

    // Maid routes (responsive - mobile-first design)
    {
        path: 'maid',
        loadComponent: () =>
            import('./layouts/app-layout/app-layout.component').then(
                (m) => m.AppLayoutComponent,
            ),
        canActivate: [authGuard, userTypeGuard('maid')],
        loadChildren: () =>
            import('@features/maid/maid.routes').then(
                (m) => m.MAID_ROUTES,
            ),
    },

    // 404 - Not Found (must be last)
    {
        path: '**',
        loadComponent: () =>
            import('./pages/not-found/not-found.component').then(
                (m) => m.NotFoundComponent,
            ),
    },
];
